export const getMaximumMonthlyBudget = (currency: string): number => {
  switch (currency) {
    case "CZK":
      return 1000000;
    case "EUR":
      return 40000;
    default:
      return 1000000; // Default to CZK if currency is unknown
  }
};
